module.exports = __webpack_public_path__ + "img/m_5.4c806296.png";